import { Component, OnInit, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FileType, FileReaderService } from 'src/app/services/file-reader.service';
import { forkJoin } from 'rxjs';
import { ImageResizeService } from 'src/app/services/image-resize.service';

@Component({
  selector: 'app-modal-fotos-consulta',
  templateUrl: './modal-fotos-consulta.component.html',
  styleUrls: ['./modal-fotos-consulta.component.scss']
})
export class ModalFotosConsultaComponent implements OnInit {

  @ViewChild('contentModalFotos', { static: false }) contentModal;
  fotos: any[] = [];
  fotosNovas: any[] = [];
  observacoes = '';

  constructor(private changeDetectorRef: ChangeDetectorRef, private imageResizeService: ImageResizeService, private fileReaderService: FileReaderService, private modalService: NgbModal) { }

  ngOnInit() {
  }

  async showModal(fotosSalvas, observacaoSalva) {
    try {
      this.fotos = fotosSalvas;
      this.observacoes = observacaoSalva;
      let modalResult = await this.modalService.open(this.contentModal, { backdrop: "static", windowClass: 'modal-fullscreen', ariaLabelledBy: 'Modal adicionar imagens consulta' }).result;
      if (modalResult == 'close') {
        this.fotos.forEach(r => r.remover = false);
        this.fotosNovas = [];
        return null;
      } else if (modalResult == 'ok') {
        let result = {
          observacoes: this.observacoes,
          fotos: [...this.fotos, ...this.fotosNovas.filter( f => !f.remover) ]
        }
        this.fotosNovas = [];
        return result;
      }
    } catch (error) {
      return null;
    }
  }

  remover(img) {
    img.remover = true;
  }


  getImages() {
    let input: HTMLElement = document.createElement('input') as HTMLInputElement;
    input.setAttribute('type', 'file');
    input.setAttribute('accept', FileType.image);
    input.setAttribute('multiple', 'multiple');

    input.onchange = (e: any) => {
      if (e.target.files.length == 0) {
        return;
      }

      let fileListPromise = [];


      for (let i = 0; i < e.target.files.length; i++) {
        let file = this.readAndResizeImage(e.target.files[i]);
        fileListPromise.push(file);
      }
      forkJoin(fileListPromise).toPromise().then(r => {
        this.fotosNovas = [...this.fotosNovas, ...r.filter( r => r ) ];
        this.changeDetectorRef.markForCheck();
      });

    }
    input.click();
  }

  async readAndResizeImage(file) {
    let image = null;
    try {
      if(['image/jpeg','image/png', 'image/tiff', 'image/pjpeg', 'image/pjp'].find( t => t == file.type)) {
        image = await this.fileReaderService.readAsDataUrl(file);
        image = await this.imageResizeService.resize(image);
      }
    } catch (error) {
      console.error(error);
    }
    return image ? { base64: image, nome: this.getImageName(file.name) } : null;
  }

  getImageName(name) {
    let result: string[] = name.split('.');
    if (result.length > 1) {
      result.pop();
    }
    return result.join('.');
  }
}
